import React, {Component} from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import MetaTags from 'react-meta-tags';
import Favicon from 'react-favicon'
import axios from "axios";

export default class Report extends Component {

    constructor (props) {
        super(props)
        this.state = {
            loggedInUser:null,
            fromDate: '',
            toDate: '',
            disabled : false
        };
        this.handleFromDate = this.handleFromDate.bind(this);
        this.handleToDate = this.handleToDate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {

                this.setState({ loggedInUser: response.data })
                console.log("=== LOG_1 === Inside componentDidMount %s with data ","User info",this.state.loggedInUser);

            }).finally(()=> {
        })
            .catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });
    }

    handleFromDate(event) {
        console.log("Changed Value -----",event.target.value)
        this.setState({
            fromDate: event.target.value
        });
    }

    handleToDate(event) {
        console.log("Changed Value -----",event.target.value)
        this.setState({
            toDate: event.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        let main = this.state.startDate
        console.log(this.state.fromDate,"FromDate ---- ----Todate",this.state.toDate);
        if(this.state.fromDate === '' || this.state.toDate === ''){
            alert(" Please provide valid  Date !!")
            return false;
        }
        if (this.state.disabled) {
            return;
        }
        this.setState({disabled: true});
        axios({
            url: 'downloadcashLoadHistoryReport?userid='+ this.state.loggedInUser+"&FromDate="+this.state.fromDate+"&ToDate="+this.state.toDate, //your url
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'cashLoadDetail.xls'); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.setState({disabled: false});
        });
    }

    render() {

        const alignBox = {
            display: "flex",
            justifyContent: "space-around"
        };

        return <div className="main-content">
            <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
            <MetaTags>
                <title>DataStream Version 2.0</title>
                <meta name="description" content="DataStream Version 2.0" />
                <meta property="og:title" content="DataStream Version 2.0" />
            </MetaTags>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Report Management</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-9">
                            <div className="card">
                                <div className="card-body">
                                    <div className="tab-content p-3 text-muted">
                                            <div className="form-group">
                                                <form onSubmit={ this.handleSubmit }>
                                                    <div className="form-group" style={alignBox}>
                                                       <div>
                                                           <label>From Date: </label>
                                                           <input type="date" id="fromDate" onChange={this.handleFromDate}/>
                                                       </div>
                                                        <div>
                                                            <label>To Date: </label>
                                                            <input type="date" id="toDate" onChange={this.handleToDate}/>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button className="btn btn-primary" onClick={this.handleClick} disabled={this.state.disabled} >Generate Report</button>
                                                    </div>
                                                </form>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;

    }

    //Function to update state from userView
    onUpdate (data) { this.setState({ data }) }
}